<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <div :class="b('wrapper')">
      <div
        v-if="walletRepo.list.length > 0"
        :class="b('currency-section')"
        class="currency-section"
      >
        <SharedBlockCurrencySelect
          :buy-rate="selectedPairBuyRate"
          :sell-rate="selectedPairSellRate"
          @pair-changed="handlePairChanged"
        />

        <div :class="[b('pairs'), { 'with-animation': shouldAnimate }]">
          <Vue3Marquee
            :duration="shouldAnimate ? 30 : 0"
            :pauseOnHover="true"
            :gap="20"
          >
            <SharedBlockCurrencyPair
              v-for="pair in pairsWithRates"
              :key="pair.currency_id_from + pair.currency_id_to"
              :pair="pair"
              :currency-map="currencyMap"
            />
          </Vue3Marquee>
        </div>
      </div>

      <div :class="b('heading')">
        <div>
          <h1 :class="b('title')">{{ $t("Кошелек") }}</h1>
          <p :class="b('subtitle')">
            {{ $t("Мультивалютные счета, обмен и заявки в одном месте") }}
          </p>
        </div>
        <span :class="b('status')">
          <i></i>{{ $t("Счета обновляются в реальном времени") }}
        </span>
      </div>

      <section
        :class="b('hero')"
        :style="heroSpotStyle"
        @pointermove="handleHeroPointerMove"
      >
        <span :class="b('spot')" aria-hidden="true"></span>
        <div :class="b('hero-copy')">
          <p :class="b('eyebrow')">
            <i></i>{{ $t("Общий баланс · эквивалент") }}
            <span>{{ heroCurrency }}</span>
          </p>
          <div :class="b('balance')">
            <span v-if="displayedFiatSymbol" :class="b('balance-symbol')">
              {{ displayedFiatSymbol }}
            </span>
            <strong>{{ displayedBalanceInteger }}</strong>
            <span :class="b('balance-fraction')">
              {{ displayedBalanceFraction }}
            </span>
          </div>

          <div :class="b('balance-tabs')">
            <button
              v-for="currency in heroCurrencies"
              :key="currency"
              :class="b('balance-tab', { active: currency === heroCurrency })"
              :disabled="isHeroCurrencyLoading"
              @click="handleHeroCurrency(currency)"
            >
              {{ currency }}
            </button>
          </div>
        </div>

        <div :class="b('hero-actions')">
          <button
            :class="b('hero-action', { primary: true })"
            @click="handleDeposit"
          >
            <span>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 5v14M6 13l6 6 6-6" />
              </svg>
            </span>
            <div>
              <b>{{ $t("Пополнить") }}</b>
              <small>{{ $t("Карта, крипто, перевод") }}</small>
            </div>
            <i>›</i>
          </button>
          <button
            :class="b('hero-action')"
            :disabled="!hasWalletBalance"
            @click="handleWithdrawal"
          >
            <span>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 19V5M6 11l6-6 6 6" />
              </svg>
            </span>
            <div>
              <b>{{ $t("Вывести") }}</b>
              <small>{{ $t("На карту или кошелёк") }}</small>
            </div>
            <i>›</i>
          </button>
          <router-link :class="b('hero-action')" :to="{ name: 'application' }">
            <span>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M4 8h13l-3-3M20 16H7l3 3" />
              </svg>
            </span>
            <div>
              <b>{{ $t("Обменять") }}</b>
              <small
                >{{ $t("Курс live") }} · {{ pairsWithRates.length }}
                {{ $t("пар") }}</small
              >
            </div>
            <i>›</i>
          </router-link>
        </div>
      </section>

      <WalletMain />

      <div :class="b('group')">
        <WalletHistory
          :history="depositWithdrawalHistory"
          @deposit="handleDeposit"
        />

        <WalletApplications :history="applicationHistory" />
      </div>
    </div>

    <transition name="opacity">
      <component
        v-if="isModalShow"
        :class="b('modal')"
        :modal="walletRepo.modal"
        :is="displayedModal"
        @update="loadData"
        @close="closeModal"
      />
    </transition>
  </div>
</template>
